import * as React from 'react'
import styled from '@emotion/styled'
import {ColorPath} from 'types/Theme'

import {cssTheme} from '../../../themes'
import {HorizontalProgressBar} from '../HorizontalProgressBar'
import {Text} from '../Text'

type Props = {
  /** Pass through classname to allow styles overrides */
  className?: string
  /** The label for the percentage bar */
  children: React.ReactNode
  /** The value for the percentage bar */
  value: number
  /** Specify the color path from the theme's colors file to explicitly set the bar's color */
  colorPath?: ColorPath
  /** The formatting of the value */
  displayFormat?: 'score' | 'percent'
}

export const LabelWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  color: ${cssTheme.colors.content.neutral.c950};
  margin-bottom: ${cssTheme.layout.spacing.s300};
`

export const ProgressBarContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
`

export const ProgressBarBar = styled.div`
  flex: 1 1;
`

const roundRatingValue = (value: number) => Math.round(value * 10) / 10

const formatValue = (value: number, valueFormat: Props['displayFormat']) => {
  switch (valueFormat) {
    case 'score':
      return roundRatingValue(value)

    case 'percent':
      return `${Math.floor(value * 10)}%`
  }
}

export const ReviewSummaryBar = ({
  children,
  value,
  displayFormat = 'score',
  colorPath,
  className
}: Props) => {
  return (
    <div className={className}>
      <LabelWrapper>
        <Text variant="bodyS">{children}</Text>
        <Text variant="labelS">{formatValue(value, displayFormat)}</Text>
      </LabelWrapper>

      <ProgressBarContainer>
        <ProgressBarBar>
          <HorizontalProgressBar
            key={value}
            value={value * 10}
            colorPath={colorPath}
          />
        </ProgressBarBar>
      </ProgressBarContainer>
    </div>
  )
}
